import CelebrationIcon from '@mui/icons-material/Celebration';
import { Dialog, Stack, Typography } from '@mui/material';
import { ProductGroups } from 'enums';
import getLocalizedText from 'features/co-pilot/translationFileProduct';
import PaiListItem from 'features/ui/base-components/pai-list-item';
import PaiButton from 'features/ui/base-components/pai-button';
import React from 'react';
import { Trans, useTranslation } from 'react-i18next';
import { makeStyles } from 'tss-react/mui';

interface Props {
  open: boolean;
  userFirstName: string;
  campaignName: string;
  productGroup: ProductGroups;

  handleClose(): void;
}

const StartCampaignSuccessDialog: React.FC<Props> = ({ open, userFirstName, campaignName, productGroup, handleClose }) => {
  const { classes } = useStyles();
  const { t } = useTranslation();

  const getLocalizedKey = (key: string) => {
    if (productGroup === ProductGroups.LEAD_BOOSTER) {
      return `${key}_LeadBooster`;
    }
    return `${key}_ActiveSourcing`;
  };

  return (
    <Dialog open={open} classes={{ paper: classes.paper }} fullWidth={true} maxWidth={'lg'}>
      <Stack direction={'row'}>
        <div className={classes.leftRow}>
          <CelebrationIcon className={classes.icon} />
          <Typography className={classes.boldText} mb={'16px'}>
            {t('congratulationsFirstName', { userFirstName })}
          </Typography>
          <Typography className={classes.text} mb={'4px'}>
            <Trans i18nKey={getLocalizedKey('campaignCreated')} values={{ campaignName }}>
              You have successfully created your recruiting outreach campaign <strong>{campaignName}</strong>.
            </Trans>
          </Typography>
          <Typography className={classes.text}>{getLocalizedText('boostConversionsInfo', productGroup, t)}</Typography>
        </div>
        <Stack className={classes.rightRow}>
          <div className={classes.content}>
            <Typography className={classes.boldText} mb={'16px'}>
              {t('keepTrackOf')}
            </Typography>
            <PaiListItem text={t('campaignStatusInfo')} size={'extra-large'} />
            <PaiListItem text={t('requiredActionsInfo')} size={'extra-large'} />
            <PaiListItem text={t('editCampaignInfo')} size={'extra-large'} />
          </div>
          <div className={classes.actions}>
            <PaiButton text={t('continueToStatus')} size={'small'} border={'rounded'} action={handleClose} />
          </div>
        </Stack>
      </Stack>
    </Dialog>
  );
};

const useStyles = makeStyles()((theme) => ({
  paper: {
    borderRadius: '16px',
  },
  boldText: {
    fontSize: theme.typography.pxToRem(30),
    fontWeight: 'bold',
  },
  text: {
    fontSize: theme.typography.pxToRem(15),
  },
  leftRow: {
    flexBasis: '50%',
    background: 'linear-gradient(to right, #4AA4FF, #5044FF)',
    borderTopRightRadius: '16px',
    borderBottomRightRadius: '16px',
    color: '#FFF',
    padding: '40px 72px',
  },
  icon: {
    fontSize: theme.typography.pxToRem(80),
  },
  rightRow: {
    flexBasis: '50%',
  },
  content: {
    padding: '120px 72px 40px 72px',
  },
  actions: {
    display: 'flex',
    justifyContent: 'flex-end',
    padding: '24px',
    marginTop: 'auto',
    borderTop: `1px solid ${theme.palette.greys.light}`,
  },
}));

export default StartCampaignSuccessDialog;
